module.exports = __webpack_public_path__ + "static/img/pet-03.26951aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/pet-03.jpg
// module id = 9sDQ
// module chunks = 0